<template>
  <v-form ref="frmMain" class="main-form form-inputs" v-model="valid" lazy-validation>
    <v-card :loading="loading" :disabled="loading">
      <v-card-title> Add New Technology </v-card-title>
      <v-card-text>
        <TextField outlined :rules="[rules.required, technologyExist]" v-model="text" label="Text" placeholder="Text" :disabled="loading"></TextField>
        <SelectField
          :items="activities"
          item-title="Value"
          item-value="id"
          :rules="[rules.minSelected]"
          v-model="selectedActivities"
          label="Activity"
          placeholder="Activity"
          hint="Select Activities"
          :menu-props="{ bottom: true, offsetY: true }"
          outlined
          multiple
          chips
          persistent-hint
          :disabled="loading"
        ></SelectField>
      </v-card-text>
      <span class="ml-5" style="color: red">{{ message }}</span>
      <v-card-actions>
        <v-row>
          <v-col md="12">
            <v-btn color="dark" class="right" @click="confirm"> <v-icon>mdi-check</v-icon>Save </v-btn>
            <v-btn text color="primary" class="right mr-5" @click="cancel">Cancel</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script lang="ts">
import Vue, { defineComponent } from "vue";
import { Technology } from "../../models/Technology";
import TechnologyService from "../../services/TechnologyService";
import SelectField from "../Fields/SelectField.vue";
import TextField from "../Fields/TextField.vue";

export default defineComponent({
  props: ["technologies", "activities"],
  data() {
    return {
      valid: false,
      text: "",
      selectedActivities: [],
      message: "",
      loading: false,
      rules: {
        required: (value:any) => !!value || "Required.",
        minSelected: (value:any) => (value && value.length > 0) || "Required.",
      },
    };
  },
  computed: {
    technologyExist() {
      this.text = this.text ? this.text.trim() : this.text;
      if (this.selectedActivities && this.selectedActivities.length > 0 && this.text) {
        var existedItem = this.technologies.find((c:any) => c.Value && c.Value.toLowerCase().trim() === this.text.toLowerCase());
        if (existedItem) {
          var existedActivityIds = this.selectedActivities.filter((c:any) => existedItem.ActivityIds.includes(c)) as string[];
          if (existedActivityIds.length > 0) {
            var existedActivityNames = this.activities.filter((c:any) => existedActivityIds.includes(c.id)).map((c:any) => c.Value) as string[];
            if (existedActivityNames) {
              return `This item already exist in the selected activity/activities: ${existedActivityNames.join()}`;
            }
          }
        }
      }
      return true;
    },
  },
  methods: {
    cancel() {
      this.text = "";
      this.selectedActivities = [];
      this.message = "";
      (this.$refs.frmMain as any).reset();
      this.$emit("cancel");
    },
    async confirm() {
      this.message = "";
      const isValid = (await (this.$refs.frmMain as any).validate()).valid;
      if (isValid) {
        var allFound = false;
        var findTechnology = this.technologies.find((c:any) => c.Value.toLowerCase() === this.text.toLowerCase()) as Technology;
        if (findTechnology) {
          allFound = this.selectedActivities.every((ai) => findTechnology.ActivityIds.includes(ai));
        }
        if (!allFound) {
          this.loading = true;
          TechnologyService.addNewWithActivities(this.text, this.selectedActivities)
            .then((res) => {
              this.$emit("confirm", res);
              this.loading = false;
              this.text = "";
              this.selectedActivities = [];
              (this.$refs.frmMain as any).reset();
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          this.message = "Technology Exists!";
        }
      }
    },
  },
  components: { SelectField, TextField },
});
</script>
<style scoped>
.main-form {
  overflow-x: hidden;
}
</style>
